// extracted by mini-css-extract-plugin
module.exports = {"marketplace-list":"NftsBuyNow_marketplace-list__1JFUN","no-nfts-found-text":"NftsBuyNow_no-nfts-found-text__1ZxFX"};